exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip.top {\n  margin-top: -52px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-2!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/app/style/tooltip-top.scss
// module id = 1860
// module chunks = 0